const phone = '0740 023 671'
const email = 'jforce@jumia.co.ke'
const supportedLanguages = ['en']
const personalInfo = {
  phoneNumberMask: '#### ### ###'
}
const paymentMethods = {
  bankAccountMask: '##############################'
}

export {
  // auxiliary objects
  phone,
  email,

  // languages
  supportedLanguages,

  // personal info
  personalInfo,

  // payment methods
  paymentMethods
}
